module.exports = __webpack_public_path__ + "static/media/34DSS4.507454f1.jpg";